import { styled } from "@mui/material/styles";

const Styles = styled("div")(() => ({
  "& .Document-upload": {
    display: "block",
    width: "100%",
    textAlign: "center",
    height: "auto",
    margin: "auto",
  },
}));
export default Styles;
